import styled from 'styled-components'

export const Container = styled.div<{ isFromEdit?: boolean }>`
  width: 100%;
  background-color: var(--color-white);
  position: relative;
  padding: 8px;
  border-radius: 10px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`

export const IconWrap = styled.div`
  position: absolute;
  right: 16px;
  top: 16px;
  cursor: pointer;
`

export const Title = styled.p<{ isFromEdit?: boolean }>`
  margin: 0;
  margin-right: auto;
  font-size: 14px;

  font-weight: 400;
  color: 'var(--color-text-secondary)';
`

export const SubTitle = styled.p`
  font-size: 14px;
  color: var(--color-text-secondary);
  text-align: center;
  margin-top: 0;
  margin-bottom: 24px;
`

export const Form = styled.div`
  display: flex;
  margin-top: 8px;
  width: 100%;
  gap: 10px;
  position: relative;
  flex-direction: column;
  align-items: flex-end;
`

export const InputContainer = styled.div`
  width: 100%;
  border: 1px solid lightgrey;
  border-radius: 10px;

  * {
    padding: 1rem;
    border-radius: inherit;
  }

  & input {
    font-weight: 600;
    font-size: 14px;
    color: rgb(68, 68, 68);
    border-color: rgb(229, 229, 229);
    border-bottom: none;
    border-color: ${({ isError }) => isError && 'var(--color-text-error)'};
  }
`

export const Input = styled.input`
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  padding: 10px 12px;
  border: 1px solid var(--color-border);
  border-radius: 12px;
  outline: none;

  &:disabled {
    background-color: var(--color-disabled-bg);
    cursor: not-allowed;
  }
`

export const Textarea = styled.textarea<{ isError?: boolean; isFromEdit?: boolean }>`
  position: relative;
  width: 100%;
  height: 110px;
  font-size: 14px;
  word-break: break-word;
  outline: none;
  border: none;
  border-color: ${({ isError }) => isError && 'var(--color-text-error)'};
`

export const TitleInput = styled.input<{ isFromEdit?: boolean }>`
  font-weight: 600;
  font-size: 14px;
  color: rgb(68, 68, 68);
  border: none;
  outline: none;
  width: 100%;
`

export const Error = styled.div`
  font-size: 12px;
  position: relative;
  color: var(--color-text-error);
  margin-top: -0.5rem;
  margin-right: auto;
`

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 8px;
  width: 100%;
  gap: 8px;
  position: relative;
  justify-content: flex-end;
`
